(() => {
	angular
		.module('main')
		.directive('deleteWorkflowTaskModal', deleteWorkflowTaskModal);

	deleteWorkflowTaskModal.$inject = ['workflowService', 'messageService'];

	function deleteWorkflowTaskModal(workflowService, messageService) {
		return {
			restrict: 'E',
			scope: {
				fromSettings: '=',
				workflow: '=',
				renewWorkflow: '&'
			},
			template: `
                      <div id="deleteWorkflowTaskModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                    <h3 class="modal-title">Delete workflow task</h3>
                                </div>
                                <div class="modal-body">
                                        <strong>Are you sure you would like to delete this task? This cannot be undone!</strong>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button type="button" class="btn btn-md btn-danger" ng-click="delete()">Yes</button>
                                    <button type="button" class="btn btn-md btn-default" data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                 `,
			replace: true,
			transclude: true,
			link(scope) {
				$(document).on('show.bs.modal', '#deleteWorkflowTaskModal', () => {
					scope.taskInfo = workflowService.getTaskInfo();
					scope.task = scope.taskInfo.task;
					scope.taskList = scope.taskInfo.taskList;
				});

				const renewWorkflow = data => {
					if (!data || !data.tasks) {
						return;
					}
					scope.renewWorkflow({ tasks: data.tasks });

					messageService.showToaster('s_5', 'workflow');
				};

				scope.delete = () => {
					if (scope.fromSettings) {
						scope.workflow = workflowService.deleteTaskFromSettings(
							scope.workflow,
							scope.taskList,
							scope.task
						);
						messageService.showToaster('s_5', 'workflow');
					} else {
						workflowService
							.deleteTask(scope.taskList, scope.task)
							.subscribe(
								result => renewWorkflow(result),
								err => messageService.handleError(err)
							);
					}
					$('#deleteWorkflowTaskModal').modal('hide');
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/deleteWorkflowTaskModal.js